import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  width: calc(50% - 0.75rem);
  margin: 1.5rem 0 0 0;
  display: flex;
  flex-direction: column;
  &:first-child, &:nth-child(2) {
    margin-top: 0;
  }
  @media (max-width: 600px) {
    width: 100%;
    &:nth-child(2) {
      margin-top: 1.5rem;
    }
  }
`

export default class HalfCell extends Component {
  render() {
    return <Box {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Grid/HalfCell.js